module.exports = __webpack_public_path__ + "static/media/texture-pink.f1cb2fde.png";